module.exports = __webpack_public_path__ + "static/media/time-icon.ea081dc3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/time-icon.svg
// module id = 1864
// module chunks = 0